import { isMoblie } from "@/assets/js/until";
let url = window.location.href
let h5UrlList = [{
    url: 'body-report/list', 
    name: '体检报告'
},
{
    url: 'body-report/detail', 
    name: '体检报告'
},
{
    url: 'body-report/import', 
    name: '体检报告'
},{
    url: 'health-archive', 
    name: '健康档案'
}
]
for(let i in h5UrlList) {
    let item = h5UrlList[i]
    
}
h5UrlList.forEach((item)=>{
    if(url.indexOf(item.url) > -1 || isMoblie()) {
        require('./flexible.js') // 移动端适配
        document.querySelector('title').innerText = item.name
    }else{
        document.querySelector('title').innerText = "汇晨互动智能健康评估系统"
    }
})

